import { Web3ReactProvider } from "@web3-react/core";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { WagmiProvider } from "wagmi";

import { store } from "./app/rootStore";
import { PushNotificationProvider } from "./contexts/PushNotificationProvider";
import Routes from "./router/Routes";
import { connectors } from "./utils/getLibrary";
import { ToastProvider } from "react-toast-notifications";
import { wagmiConfig } from './wagmi'

import "@rainbow-me/rainbowkit/styles.css";
import "./App.css";
import 'react-photo-view/dist/react-photo-view.css';


const queryClient = new QueryClient();

const App = () => {
  return (
    <ToastProvider autoDismiss={true} autoDismissTimeout={3000}>
      <Web3ReactProvider connectors={connectors}>
        <WagmiProvider config={wagmiConfig}>
          <QueryClientProvider client={queryClient}>
            <RainbowKitProvider>
              <Provider store={store}>
                <PushNotificationProvider>
                  <BrowserRouter>
                    <Routes />
                  </BrowserRouter>
                </PushNotificationProvider>
              </Provider>
            </RainbowKitProvider>
          </QueryClientProvider>
        </WagmiProvider>
      </Web3ReactProvider>
    </ToastProvider>
  );
};

export default App;
